import script from "./PricingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPage.vue?vue&type=script&setup=true&lang=js"

import "./PricingPage.vue?vue&type=style&index=0&id=d15f6f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d15f6f70"]])

export default __exports__